import { render, staticRenderFns } from "./UiUserCard.vue?vue&type=template&id=fa588a54&"
import script from "./UiUserCard.vue?vue&type=script&lang=js&"
export * from "./UiUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports